import { defineStore } from 'pinia';
import { ref } from 'vue';
import { StoreNames } from '../../../shared/store-names';
export const useAccountStore = defineStore(StoreNames.Account, () => {
  const id = ref('demo-account');
  const name = ref('Demo Retail');
  const initials = ref('');
  const locale = ref('en-US');
  const currency = ref('USD');
  const whReplenishmentActive = ref(true);
  const timeZone = ref('UTC');
  const customDataSchema = ref<
    Record<
      string,
      {
        key: string;
      }[]
    >
  >({});
  const accountLastReplenishmentDate = ref(new Date().toISOString());
  const calculationDoneAt = ref(new Date().toISOString());
  const promotionAiEnabled = ref(false);
  const replenishmentPickingListActive = ref(true);
  const packSupported = ref(false);
  const isRunningDailyUpload = ref(false);
  const isUpdatingReplenishments = ref(false);
  const productSimilaritySupport = ref(false);
  const searchMatchingStrategy = ref<'fuzzy' | 'exact'>('fuzzy');
  const searchBulkOperationsDisabled = ref(false);
  const itContactEmail = ref<null | string>(null);
  const zeroingEnabled = ref(false);
  const fetching = ref(false);
  const fetched = ref(true);
  async function fetch(force = false) {
    void force;
    fetching.value = false;
    fetched.value = true;
  }
  function clear() {}
  return {
    id,
    name,
    initials,
    locale,
    currency,
    whReplenishmentActive,
    timeZone,
    customDataSchema,
    accountLastReplenishmentDate,
    promotionAiEnabled,
    packSupported,
    isUpdatingReplenishments,
    isRunningDailyUpload,
    productSimilaritySupport,
    fetching,
    fetch,
    fetched,
    clear,
    replenishmentPickingListActive,
    calculationDoneAt,
    searchMatchingStrategy,
    searchBulkOperationsDisabled,
    itContactEmail,
    zeroingEnabled,
  };
});
